import { a159, a160, a161, a162, a164, a762, a763 } from "Components/Api/RootApiPath";

export const sendFormData = async ({ formData, data }) => {
    const response = await fetch(a154, {
      method: "POST",
      body: formData,
    });
  
    if (!response.ok) {
      throw new Error("Failed to send form data");
    }
  
    const jsondata = await response.json();
  
    if (jsondata?.Id) {
      await sendProductData(jsondata.Id, data);
    }
  
    return jsondata;
  };
  

  export const fetchPurchaseEntryDetail = async ({queryKey}) => {
    const [,id,clientCode] = queryKey
    try {
      const data = await fetch(a763, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id, clientCode }),
      });
      if (!data.ok) {
        throw new Error(
          `${response.statusText || "Failed to fetch purchase entry"}`
        );
      }
      return data?.json();
  
      return data;
    } catch (e) {
      console.log(e)
      throw new Error(`${"Failed to fetch purchase entrty, try again later"}`)
    }
  };

  export const fetchPurchaseEntryItems = async ({queryKey}) => {
    const [,RDPurchaseId,ClientCode] = queryKey
    try {
      const data = await fetch(a762, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ RDPurchaseId, ClientCode }),
      });
      if (!data.ok) {
        throw new Error(
          `${response.statusText || "Failed to fetch purchase entry items"}`
        );
      }
      return data?.json();
  
      return data;
    } catch (e) {
      console.log(e)
      throw new Error(`${"Failed to fetch purchase entrty items, try again later"}`)
    }
  };

  export const fetchLotList = async ({queryKey}) => {
    const [,ClientCode] = queryKey
    try {
      const data = await fetch(a159, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ClientCode }),
      });
      if (!data.ok) {
        throw new Error(
          `${response.statusText || "Failed to fetch lot list"}`
        );
      }
      return data?.json();
  
      return data;
    } catch (e) {
      console.log(e)
      throw new Error(`${"Failed to fetch lot list, try again later"}`)
    }
  };
  

  